import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { PaymentStore } from '../service/payment.store';
import { Payment } from '../models/payment';

@Injectable()
export class PaymentsResolver implements Resolve<any> {
  constructor(
    private paymentStore: PaymentStore,
    private translateService: TranslateService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<Payment>> {
    const id = route.params[ 'id' ];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
    }

    return this.paymentStore.loadPayments(id).first();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/payments.resolver.ts